import React, { useCallback, useRef, useState } from "react";

import { BsUpload } from "react-icons/bs";
import { LiaTimesSolid } from "react-icons/lia";

import { AnimatePresence, motion } from "framer-motion";
import { IoIosArrowForward, IoIosArrowRoundBack } from "react-icons/io";
import { IoDocumentOutline } from "react-icons/io5";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { TbChecks } from "react-icons/tb";
import AlertMessage from "../../../components/alert/AlertMessage";
import Loading from "../../../components/loading/Loading";
import ModalAlt from "../../../components/modal/ModalAlt";
import { ERROR_MSG } from "../../../constants/common";
import { SET_ERROR } from "../../../constants/contexConstant";
import { CREATE_TICKET_ENDPOINT } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import useFileUploadAndRemove from "../../../hooks/useFileUploadAndRemove";
import cn from "../../../lib/cn";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import H4 from "../../../shared/typography/H4";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import { renderFileIcons } from "../../../utils/fileUtils";
const queryIcons = [
    <MdOutlineCurrencyRupee />,
    <TbChecks />,
    <IoDocumentOutline />,
];

let TICKET_LENGTH = 30;
const defaultHeader = ["Create Support Ticket", "Create Support Ticket"];
const defaultSubHeader = [
    "Choose a topic to continue",
    "Choose a  sub-topic to continue",
];

const WrapperComponent = ({
    type = "bottom-drawer",
    isOpen,
    onClose,
    children,
    onClick,
}) => {
    if (type === "div") {
        return (
            <div className="flex  pt-[10rem]  justify-center items-center">
                <div className="w-full lg:w-1/2  rounded-3xl">{children}</div>
            </div>
        );
    } else {
        return (
            <>
                <div className="lg:hidden">
                    <BottomDrawer
                        contentClass="min-h-[60vh] bg-white"
                        showClose={false}
                        isOpen={isOpen}
                        onClick={onClose}
                        childrenClassName="pt-0"
                    >
                        {children}
                    </BottomDrawer>
                </div>

                <div className="hidden lg:block">
                    <ModalAlt
                        isOpen={isOpen}
                        onClose={onClose}
                        innerTimes={false}
                    >
                        {children}
                    </ModalAlt>
                </div>
            </>
        );
    }
};
const PopupMeta = ({
    isOpen,
    onClose,
    meta,
    onCreate,
    header = defaultHeader,
    subHeader = defaultSubHeader,
    wrapperType = "bottom-drawer",
    wrapperClass,
    type,
}) => {
    const {
        file,
        setFile,
        uploadedDoc,
        uploading,
        setUploadedDoc,
        handleFileChange,
        removeFile,
    } = useFileUploadAndRemove();
    const emptyDivRef = useRef(null);

    const { state, dispatch } = useContextState();

    const [selectedQuery, setSelectedQuery] = useState(type || "");
    const [selectedSubtype, setSelectedSubtype] = useState("");

    const [description, setDescription] = useState("");

    const [descriptionError, setDescriptionError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleQuerySelect = (query) => {
        setSelectedQuery(query);
        setSelectedSubtype("");
    };
    const handleSubtypeSelect = (subtype) => {
        setSelectedSubtype(subtype);
    };

    const cleanUpForm = useCallback(() => {
        setDescription("");
        setSelectedQuery(type || "");
        setSelectedSubtype("");
        setUploadedDoc([]);
        setFile([]);
        onClose();
    }, [onClose, setFile, setUploadedDoc, type]);

    const handleFormSubmit = useCallback(
        async (e) => {
            e.preventDefault();

            setDescriptionError("");
            let fileIds = uploadedDoc.map((item) => item.file);
            try {
                setLoading(true);
                const body = {
                    message: description,
                    plantId: state?.user?.plant?.plantId,
                    tag: selectedQuery,
                    subTag: selectedSubtype,
                    fileIds,
                };

                let res = await request.authPost({
                    endpoint: `${CREATE_TICKET_ENDPOINT}`,
                    body,
                });

                setLoading(false);
                onCreate(res?.data?.ticket);

                cleanUpForm();
            } catch (error) {
                setLoading(false);

                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        },
        [
            cleanUpForm,
            description,
            dispatch,
            onCreate,
            selectedQuery,
            selectedSubtype,
            state?.user?.plant?.plantId,
            uploadedDoc,
        ]
    );

    const handleChangeFileInput = async (e) => {
        await handleFileChange(e);
        setTimeout(() => {
            emptyDivRef.current.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "end",
                offset: 10,
            });
        }, [100]);
    };

    const handleClosePopup = () => {
        onClose();
        cleanUpForm();
    };
    return (
        <AnimatePresence>
            <WrapperComponent
                type={wrapperType}
                isOpen={isOpen}
                onClose={handleClosePopup}
                onClick={cleanUpForm}
            >
                <div className={cn("pb-10.4 bg-white", wrapperClass)}>
                    {!meta ? (
                        <div className="bg-white mx-2 md:mx-4  ">
                            <AlertMessage
                                onClick={cleanUpForm}
                                message="Not available at the moment. please comeback later"
                                error
                            ></AlertMessage>
                        </div>
                    ) : (
                        <div className="h-full flex  flex-col ">
                            <div className="bg-blue-100 rounded-t-3xl">
                                <Container>
                                    <div className="flex gap-2 items-center py-2.4  ">
                                        {/* @DESC:: Meta header @habib610 Thu August 22,2024 */}
                                        {!type && selectedQuery && (
                                            <div
                                                role="button"
                                                onClick={() => {
                                                    selectedSubtype
                                                        ? setSelectedSubtype("")
                                                        : setSelectedQuery("");
                                                }}
                                            >
                                                <H4 className="text-white">
                                                    <IoIosArrowRoundBack />
                                                </H4>
                                            </div>
                                        )}
                                        <div>
                                            <H4 className="text-white xl:text-base 2xl:text-base font-vietnam">
                                                {!selectedQuery
                                                    ? header[0]
                                                    : !selectedSubtype
                                                    ? selectedQuery
                                                    : header[1]}
                                            </H4>
                                            <P className="text-gray-370 xl:text-sm 2xl:text-sm font-vietnam">
                                                {!selectedQuery
                                                    ? subHeader[0]
                                                    : !selectedSubtype
                                                    ? subHeader[1]
                                                    : ""}
                                            </P>
                                        </div>
                                        <H4
                                            className="text-white absolute top-1 right-1 hover:cursor-pointer"
                                            type="button"
                                            onClick={cleanUpForm}
                                        >
                                            <LiaTimesSolid />
                                        </H4>
                                    </div>
                                </Container>
                            </div>
                            <div className="bg-white ">
                                <Container className="bg-white">
                                    <div className="bg-white rounded-t-2xl   flex-1 overflow-x-hidden overflow-y-auto rounded-b-none pb-2 h-auto ">
                                        {!selectedQuery &&
                                            Object.keys(meta)?.map(
                                                (query, index) => (
                                                    <motion.div
                                                        initial={{ x: "100%" }}
                                                        animate={{ x: 0 }}
                                                        exit={{ x: "-100%" }}
                                                        transition={{
                                                            duration: 0.2,
                                                            ease: "easeInOut",
                                                        }}
                                                        key={index}
                                                        role="button"
                                                        className="flex justify-between items-center py-2 border-b overflow-hidden"
                                                        onClick={() =>
                                                            handleQuerySelect(
                                                                query
                                                            )
                                                        }
                                                    >
                                                        <div className="flex items-center gap-2">
                                                            <div className="p-0.5 bg-blue-300 rounded-full">
                                                                <P>
                                                                    {
                                                                        queryIcons[
                                                                            index
                                                                        ]
                                                                    }
                                                                </P>
                                                            </div>
                                                            <P className="text-secondary xl:text-sm 2xl:text-base">
                                                                {query}
                                                            </P>
                                                        </div>
                                                        <P className="text-secondary">
                                                            <IoIosArrowForward />
                                                        </P>
                                                    </motion.div>
                                                )
                                            )}
                                        {selectedQuery &&
                                            !selectedSubtype &&
                                            Object.keys(
                                                meta[selectedQuery]
                                            ).map((subtype, subIndex) => (
                                                <motion.div
                                                    initial={{ x: "100%" }}
                                                    animate={{ x: 0 }}
                                                    exit={{ x: "-100%" }}
                                                    transition={{
                                                        duration: 0.3,
                                                        ease: "easeInOut",
                                                    }}
                                                    role="button"
                                                    key={subIndex}
                                                    onClick={() =>
                                                        handleSubtypeSelect(
                                                            subtype
                                                        )
                                                    }
                                                    className="flex justify-between items-center py-2 border-b overflow-hidden"
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <P className="text-secondary xl:text-sm 2xl:text-base">
                                                            {subtype}
                                                        </P>
                                                    </div>
                                                    <P className="text-secondary">
                                                        <IoIosArrowForward />
                                                    </P>
                                                </motion.div>
                                            ))}
                                        {selectedQuery && selectedSubtype && (
                                            <div className="pt-1.2">
                                                <div className="flex flex-col gap-1">
                                                    <P className="bg-blue-300 w-max text-secondary rounded-3xl px-1 py-0.1 xl:text-sm 2xl:text-sm">
                                                        {selectedQuery}
                                                    </P>

                                                    <P className="bg-blue-300  w-max text-secondary rounded-3xl px-1 py-0.1 xl:text-sm 2xl:text-sm">
                                                        {selectedSubtype}
                                                    </P>
                                                </div>
                                                <div className="mt-1">
                                                    <label htmlFor="description">
                                                        <P className="mb-0.5 xl:text-sm 2xl:text-sm">
                                                            Description
                                                            <span>*</span>
                                                        </P>
                                                    </label>
                                                    <textarea
                                                        id="description"
                                                        value={description}
                                                        onChange={(e) => {
                                                            setDescription(
                                                                e.target.value
                                                            );
                                                            if (
                                                                e.target.value
                                                                    .length >=
                                                                TICKET_LENGTH
                                                            )
                                                                setDescriptionError(
                                                                    ""
                                                                );
                                                            else
                                                                setDescriptionError(
                                                                    `Minimum ${TICKET_LENGTH} characters is required!`
                                                                );
                                                        }}
                                                        placeholder="Write a brief description of your query"
                                                        className={cn(
                                                            "w-full text-sm border border-blue-400 rounded-lg p-1 resize-none",
                                                            {
                                                                "border-red":
                                                                    descriptionError,
                                                            }
                                                        )}
                                                        rows="2"
                                                    />

                                                    {descriptionError && (
                                                        <p className="text-red text-sm xl:text-sm ">
                                                            {descriptionError}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="mt-1 ">
                                                    {uploading ? (
                                                        <P className="text-center flex justify-center">
                                                            <Loading />
                                                        </P>
                                                    ) : (
                                                        <>
                                                            <P className="mb-0.5 xl:text-sm 2xl:text-sm">
                                                                Upload file
                                                                (optional)
                                                            </P>
                                                            <label
                                                                role="button"
                                                                className="border border-blue-400 rounded-lg p-0.5 px-0-0.2 w-full text-center flex items-center justify-center cursor-pointer mb-0.4"
                                                                htmlFor="fileUploadInput"
                                                            >
                                                                <P className="flex items-center gap-0.4 xl:text-sm 2xl:text-base text-secondary">
                                                                    <BsUpload />
                                                                    Click here
                                                                    to upload
                                                                    file
                                                                </P>
                                                            </label>
                                                        </>
                                                    )}
                                                    {/* Hidden File Input */}
                                                    <input
                                                        type="file"
                                                        id="fileUploadInput"
                                                        name="fileUploadInput"
                                                        onClick={(e) =>
                                                            (e.target.value =
                                                                null)
                                                        }
                                                        onChange={(e) =>
                                                            handleChangeFileInput(
                                                                e
                                                            )
                                                        }
                                                        className="hidden"
                                                    />
                                                    <div className="flex flex-col-reverse">
                                                        {file.length > 0 &&
                                                            file.map(
                                                                (
                                                                    doc,
                                                                    index
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            index
                                                                        }
                                                                        className="flex justify-between items-center border border-blue-400 bg-gray-100 rounded-lg p-1 py-0.5 mb-0.5 gap-0.2"
                                                                    >
                                                                        <div className="flex items-center gap-0.5">
                                                                            <div className="text-xxl mr-0.5 text-gray-140 ">
                                                                                {renderFileIcons(
                                                                                    doc.name
                                                                                )}
                                                                            </div>
                                                                            <P className="text-secondary xl:text-sm 2xl:text-sm truncate w-[230px] ">
                                                                                {
                                                                                    doc.name
                                                                                }
                                                                            </P>
                                                                        </div>
                                                                        <button
                                                                            onClick={() =>
                                                                                removeFile(
                                                                                    index
                                                                                )
                                                                            }
                                                                            className="text-red-500 hover:text-red-700 text-xl"
                                                                        >
                                                                            <LiaTimesSolid />
                                                                        </button>
                                                                    </div>
                                                                )
                                                            )}
                                                    </div>
                                                </div>
                                                <Button
                                                    onClick={handleFormSubmit}
                                                    className="mt-2 w-full xl:text-sm 2xl:text-sm rounded-full"
                                                    variant="primary"
                                                    isLoading={loading}
                                                    disabled={
                                                        description.length <
                                                            TICKET_LENGTH ||
                                                        loading
                                                    }
                                                >
                                                    Create Support Ticket
                                                </Button>
                                                <div
                                                    ref={emptyDivRef}
                                                    className="mt-1"
                                                ></div>
                                            </div>
                                        )}
                                    </div>
                                </Container>
                            </div>
                        </div>
                    )}
                </div>
            </WrapperComponent>
        </AnimatePresence>
    );
};

export default PopupMeta;
